<template>
  <div class="login">
    <LoginLogo></LoginLogo>
    <LoginDescription></LoginDescription>
    <img src="@/assets/divider.png" class="divider" />
    <div class="error" v-if="errors.length">
      <ul>
        <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
      </ul>
    </div>
    <div class="grid-container">
      <div class="store-manager">
        <LoginForm
          heading="Store Manager"
          color="orange"
          buttonText="Get Started"
          key="1"
          v-bind:saveLdap="true" />
      </div>
      <div class="non-store-manager">
        <LoginForm
          heading="Non-store Manager"
          color="purple"
          buttonText="Get Started"
          key="2"
          v-bind:saveLdap="false" />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import LoginLogo from '@/components/LoginLogo.vue'
import LoginDescription from '@/components/LoginDescription.vue'
import LoginForm from '@/components/LoginForm.vue'
import eventBus from '@/eventBus'

import UserService from '@/services/UserService'
import RecordService from '@/services/RecordService'

export default {
  name: 'login',
  components: {
    LoginLogo,
    LoginDescription,
    LoginForm
  },
  data() {
    return {
      errors: [],
      userData: {}
    }
  },
  methods: {
    checkRecords(ldap) {
      RecordService.getPlayerScores().then((resp) => {
        let data = resp.data
        
        let user = data.filter(function(player) {
          return player["SM_USER_ID"] == ldap
        })

        //eslint-disable-next-line no-console
        console.log(user)

        if(user.length > 0) {
          this.errors = []
          this.errors.push('Sorry! You can only play game once.');
        } else {
          this.$store.dispatch('saveUser', this.userData)
          this.$router.push({ path: '/trivia' })
        }
      })
    }
  },
  beforeDestroy() {
    eventBus.$off("save-ldap");
    eventBus.$off("check-ldap");
  },
  mounted() {
    this.$ga.page('/')
    this.$store.dispatch('resetState')
    eventBus.$on('save-ldap', (ldap) => {
      if(ldap.length < 1) {
        this.errors = []
        return this.errors.push('Please Enter Your LDAP');
      }
      let LDAP = ldap.toUpperCase()
      UserService.getUser(LDAP).then((resp) => {
        let userData = resp.data
        this.userData = userData[0]

        if(userData.length) {
          this.checkRecords(userData[0].SM_USER_ID)
        } else {
          this.errors = []
          this.errors.push('Could not find LDAP');
        }
      })
    })

    eventBus.$on('check-ldap', (ldap) => {
      if(ldap.length < 1) {
        this.errors = []
        return this.errors.push('Please Enter Your LDAP');
      }
      this.$router.push({ path: '/trivia' })
    })
  }
}
</script>
<style lang="scss">
.login {
  margin: 0 auto;
  width: 100%;
}
.divider {
  opacity: 0.2;
  margin: 20px 0;
}
.grid-container {
  display: grid;
  grid-template-columns: 20% 30% 30% 20%;
}
.store-manager {
  grid-column-start: 2;
  grid-column-end: 2;
}

.non-store-manager {
  grid-column-start: 3;
  grid-column-end: 3;
}

.error {
  position: relative;
  padding: .75rem 1.25rem;
  border: 1px solid transparent;
  border-radius: .25rem;
  color: #c60000;
  background-color: #c2b0fa;
  border-color: #9071eb;
  max-width: 400px;
  margin: 0 auto;
  font-weight: bold;

  ul {
    list-style-type: none;
    margin:0;
    padding:0;
  }
}
</style>